import React from 'react';
import { FaInstagram, FaFacebookF, FaXTwitter } from 'react-icons/fa6';
import { HiOutlineArrowRight } from 'react-icons/hi2';
import { FiHeart } from 'react-icons/fi';
import { PiLeafLight } from 'react-icons/pi';
import { GoShieldCheck } from 'react-icons/go';
import { TbTruckDelivery } from 'react-icons/tb';

const Footer = () => {
  return (
    <footer className="bg-white pt-20 pb-10 px-8 md:px-20 border-t border-rose-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          
          {/* Brand */}
          <div className="col-span-1 md:col-span-1">
            <h2 className="text-2xl font-black text-rose-600 tracking-tighter mb-4">EVEYA</h2>
            <p className="text-rose-900/60 text-sm leading-relaxed">
              Designed for your comfort and Join our mission for better period care.
            </p>
            <div className="flex gap-4 mt-6">
              <FaInstagram className="text-rose-400 hover:text-rose-600 cursor-pointer" size={20} />
              <FaFacebookF className="text-rose-400 hover:text-rose-600 cursor-pointer" size={18} />
              <FaXTwitter className="text-rose-400 hover:text-rose-600 cursor-pointer" size={18} />
            </div>
          </div>

          {/* Links */}
          <div className="col-span-1">
            <h4 className="font-bold text-rose-950 uppercase text-xs tracking-widest mb-6">Shop</h4>
            <ul className="text-rose-900/60 text-sm space-y-4 font-medium">
              <li className="hover:text-rose-600 cursor-pointer">Day Pads</li>
              <li className="hover:text-rose-600 cursor-pointer">Wellness Kits</li>
    
            </ul>
          </div>

          {/* Support */}
          <div className="col-span-1">
            <h4 className="font-bold text-rose-950 uppercase text-xs tracking-widest mb-6">Help</h4>
            <ul className="text-rose-900/60 text-sm space-y-4 font-medium">
          
              
              <li className="hover:text-rose-600 cursor-pointer"><a href='/terms-conditions'>Terms & Conditions</a></li>
              <li className="hover:text-rose-600 cursor-pointer"><a href='/privacy-policy'>Privacy Policy</a></li>
                  <li className="hover:text-rose-600 cursor-pointer"><a href='/refund-policy'>Refund Policy</a></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="bg-rose-50 p-8 rounded-[2rem]">
            <h4 className="font-bold text-rose-950 text-sm mb-4">Join the Eveya</h4>
            <div className="relative">
              <input type="email" placeholder="Your email" className="w-full bg-white rounded-full py-3 px-5 text-sm outline-none border border-rose-100" />
              <button className="absolute right-1 top-1 bg-rose-500 text-white p-2 rounded-full"><HiOutlineArrowRight /></button>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-8 py-10 border-t border-rose-50">
          <div className="flex items-center gap-3 text-rose-900/40 font-bold uppercase text-[10px] tracking-widest">
            <PiLeafLight size={28} className="text-rose-400" /> 100% Organic
          </div>
          <div className="flex items-center gap-3 text-rose-900/40 font-bold uppercase text-[10px] tracking-widest">
            <GoShieldCheck size={28} className="text-rose-400" /> Toxin Free
          </div>
          <div className="flex items-center gap-3 text-rose-900/40 font-bold uppercase text-[10px] tracking-widest">
            <TbTruckDelivery size={28} className="text-rose-400" /> Discrete Delivery
          </div>
          <div className="flex items-center gap-3 text-rose-900/40 font-bold uppercase text-[10px] tracking-widest">
            <FiHeart size={28} className="text-rose-400" /> Vegan Friendly
          </div>
        </div> */}

        <p className="text-center text-xs text-rose-900/30 mt-10">
          &copy; 2026 EVEYA. Made for your most comfortable flow.
        </p>
      </div>
    </footer>
  );
};

export default Footer;